module.exports = __webpack_public_path__ + "static/media/itau-ico.5fb5d556.svg";